import "./StickersToolsItems.scss";
import { renderList } from "common/vue/render-list";
import { cn } from "tailwind-variants";

export default function StickersToolsItems({ value, items = [], onChange, ...restProps }) {
  function handleChange(itemValue) {
    onChange?.(itemValue);
  }

  return (
    <div {...restProps} className={cn("stickers-tools-items")}>
      {renderList(items, item => (
        <div
          className={cn("stickers-tools-items__item", {
            "stickers-tools-items__item--selected": item.value === value
          })}
          key={item.value}
          onClick={() => {
            handleChange(item.value);
          }}
          data-testid="stickers-tools-items-div"
        >
          <img
            className={cn(
              "stickers-tools-items__icon",
              `stickers-tools-items__icon--${item.value}`
            )}
            src={item.icon}
            width={58}
            height={58}
          />{" "}
          {item.label}
        </div>
      ))}
    </div>
  );
}
